'use strict';
import $ from 'jquery';
import ModalView from '../../js/components/ModalView';
import modalTemplate   from './templates/_CurrencyWarningModal.hbs';


class CurrencyWarningModal extends ModalView {
  get events() {
    return {
      'click .u-form-submit': 'submitForm'
    };
  }

  initialize() {
    super.initialize({ template: modalTemplate });
  }

  open(data) {
    super.open(data);
  }

  submitForm() {
    this.close();
    return false;
  }
}

export function createCurrencyWarningModal() {
  let instance = new CurrencyWarningModal();
  let currency = $('#InvalidCurrency[value]').val();
  if (currency) {
    instance.open();
  }
}


// WEBPACK FOOTER //
// ./assets/components/CurrencyWarningModal/CurrencyWarningModal.js